const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_TYPE_AARAKOCRA,
  CREATURE_TYPE_HUMANOID,
} = require('./../../../../creatureTypeIdList')
const {
  SPEED_FLY,
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  LANG_AARAKOCRA,
  LANG_AURAN,
} = require('./../../../../languageIdList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {DAMAGE_SLASHING} = require('./../../../../damageTypeList')
const {aarakocraDescriptionList} = require('./../../../../textCommonParts')
const {ABILITY_DIVE_ATTACK} = require('./../../../../creatureAbilityList')
const {ALIGNMENT_NG} = require('./../../../../aligmentList')
const {CR_1_4} = require('./../../../../crList')
const {CREATURE_AARAKOCRA} = require('./../../../../creatureIdList')
const {GEAR_JAVELIN} = require('./../../../../gearIdList')
const {GENDER_FEMALE} = require('./../../../../genderList')
const {PROF_DOUBLE} = require('./../../../../proficiencyList')
const {SIZE_MEDIUM} = require('./../../../../sizeList')
const {SKILL_PERCEPTION} = require('./../../../../skillList')
const {SOURCE_MM} = require('./../../../../sourceList')

module.exports = {
  name: 'Ааракокра',
  nameEn: 'Aarakocra',
  id: CREATURE_AARAKOCRA,
  description: aarakocraDescriptionList,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_HUMANOID,
    CREATURE_TYPE_AARAKOCRA,
  ],
  alignmentId: ALIGNMENT_NG,
  armor: 12,
  hp: {
    diceCount: 3,
  },
  speed: {
    [SPEED_WALK]: 20,
    [SPEED_FLY]: 50,
  },
  params: {
    [PARAM_STR]: 10,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 10,
    [PARAM_INT]: 11,
    [PARAM_WIT]: 12,
    [PARAM_CHA]: 11,
  },
  skillCollection: {
    [SKILL_PERCEPTION]: PROF_DOUBLE,
  },
  languageList: [
    LANG_AARAKOCRA,
    LANG_AURAN,
  ],
  cr: CR_1_4,
  source: {
    id: SOURCE_MM,
    page: 14,
  },
  featureList: [
    {
      id: ABILITY_DIVE_ATTACK,
      damageStr: '3 (1к6)',
    },
  ],
  actionList: [
    {
      name: 'Коготь',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 4,
        range: 5,
        hit: {
          type: DAMAGE_SLASHING,
          diceCount: 1,
          diceType: 4,
          diceBonus: 2,
        },
      },
    },
    {
      gearId: GEAR_JAVELIN,
    },
  ],
  genderId: GENDER_FEMALE,
}
